import React, { useState } from 'react';
import '../styles/HomeBanner.css';
import '../styles/Home.css';
import PopupForm from './Booking'; // ✅ Import the popup form
import { useNavigate } from 'react-router-dom';
import Header from './Header';

const HomeBanner = () => {
  const [bookpopup, setBookPopup] = useState(false);

  const handleClick = () => {
    setBookPopup(true);
  };

  const handleClose = () => {
    setBookPopup(false);
  };

  return (
    <div className="home-header">
      <div className="home-banner">
        <div className="sub-banner">
          <div className="sub-inner-one">
            <div className="inner-container">
              <h5 className="tax-time">Tax TimeZ
        </h5>
              <h3 className="services-text">Services</h3>
              <button className="book-button" onClick={handleClick}>
                Schedule A Call
              </button>

              {/* ✅ Show popup modal */}
              {bookpopup && <PopupForm isOpen={bookpopup} onClose={handleClose} />}
            </div>
          </div>

          <div className="sub-inner-two">
            {/* Optionally insert an image here */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeBanner;
